import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { HR } from 'foundations-components/transitional/components/HR';
import ACNavigatorButton from 'academy-common-lib/components/navigation/contentNavigator/ACNavigatorButton';
import { getHumanizedDuration } from '../../utils/utils.migrated';
import { TRACK_COMPLETE_URL_FRAGMENT, TRACK_EXAM_URL_FRAGMENT, TRACK_RECOMMENDATIONS_URL_FRAGMENT } from '../../constants/Navigation.legacy';
import NavigatorExamButton from './NavigatorExamButton';
import TrackViewAwardLink from '../TrackCard/TrackViewAwardLink';
import { HasParentPlaylist, NextPlaylistContent } from '../../features/playlistContent/index.migrated';
import LessonNavigator from './LessonNavigator';
import { lessonToLessonCardModel } from '../../features/lessons/lessonUtils';
import { SCREENS } from '../../constants/Tracking.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CourseNavigator = ({
  track,
  trackProgress,
  activeContentId,
  activeLessonId,
  assetProgress,
  lessonFragment,
  isTrackIntro
}) => {
  const {
    id: trackId,
    introVideo,
    lessons
  } = track;
  const award = trackProgress === null || trackProgress === void 0 ? void 0 : trackProgress.trackAward;
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "course-navigator",
    paddingBlockEnd: "1600",
    children: [introVideo && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ACNavigatorButton, {
        active: isTrackIntro,
        "data-test-id": "course-navigator-introduction",
        helpText: getHumanizedDuration(introVideo.duration || 0),
        title: introVideo.name,
        to: `/tracks/${trackId}/intro`
      }), /*#__PURE__*/_jsx(HR, {
        margin: "0"
      })]
    }), lessons.map(lesson => /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(LessonNavigator, {
        active: activeLessonId === lesson.id,
        activeAssetId: activeContentId,
        assets: lesson.content.map(asset => Object.assign({}, asset, {
          completed: assetProgress[asset.id] === 'COMPLETED'
        })),
        chirpLesson: lesson,
        lesson: lessonToLessonCardModel({
          lesson
        }),
        screen: SCREENS.TRACK,
        track: track,
        trackId: trackId
      }), /*#__PURE__*/_jsx(HR, {
        margin: "0"
      })]
    }, lesson.id)), track.exam && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NavigatorExamButton, {
        active: lessonFragment === TRACK_EXAM_URL_FRAGMENT,
        award: award,
        track: track,
        trackProgress: trackProgress
      }), /*#__PURE__*/_jsx(HR, {
        margin: "0"
      })]
    }), track.certification && !track.exam && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ACNavigatorButton, {
        active: lessonFragment === TRACK_COMPLETE_URL_FRAGMENT,
        helpText: /*#__PURE__*/_jsx(TrackViewAwardLink, {
          award: award,
          certification: true,
          trackId: trackId,
          useButton: false
        }),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.certification.navigation.heading"
        }),
        to: `/tracks/${trackId}/${TRACK_COMPLETE_URL_FRAGMENT}`
      }), /*#__PURE__*/_jsx(HR, {
        margin: "0"
      })]
    }), /*#__PURE__*/_jsx(HasParentPlaylist, {
      fallback: /*#__PURE__*/_jsx(ACNavigatorButton, {
        active: lessonFragment === TRACK_RECOMMENDATIONS_URL_FRAGMENT,
        "data-test-id": "course-navigator-recommendations",
        helpText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.recommendations.navigation.subheading"
        }),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.recommendations.navigation.heading"
        }),
        to: `/tracks/${track.id}/recommendations`
      }),
      children: /*#__PURE__*/_jsx(NextPlaylistContent, {
        render: ({
          title,
          subtitle,
          url,
          urlFragments,
          showPlaylistNavigatorCta
        }) => showPlaylistNavigatorCta ? /*#__PURE__*/_jsx(ACNavigatorButton, {
          active: urlFragments.includes(lessonFragment),
          "data-test-id": "course-navigator-next-playlist-content",
          helpText: subtitle,
          title: title,
          to: url
        }) : null,
        trackId: track.id
      })
    }), /*#__PURE__*/_jsx(HR, {
      margin: "0"
    })]
  });
};
export default CourseNavigator;